import knowUs from "@/assets/landing/know_us.webp";
import DotGrid from "./ui/dotGrid";
import PillButton from "./ui/pillButton";
import Reveal from "./ui/reveal";

export default function WhyNodric() {
  return (
    <section className="relative overflow-hidden bg-linear-to-b from-white via-[#e8f1ff] to-[#9cc4ff] py-16 md:py-24">
      <DotGrid color="rgba(12,123,254,0.18)" size={30} />

      <div className="relative z-10 mx-auto max-w-350 px-6 md:px-12">
        <Reveal>
          <div className="group relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src={knowUs}
              alt="Nodric conecta la infraestructura de tu negocio"
              className="h-70 w-full object-cover transition-transform duration-1200 group-hover:scale-[1.03] md:h-140"
            />

          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="font-body mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-nodric-ink/80 md:text-[15px]">
            ¿Por qué seguir pagando por cada tarea ejecutada? Reducimos tus
            costos considerablemente al eliminar las ineficiencias de los
            sistemas cerrados. Recupera miles de horas y reinviértelas en lo que
            realmente genera ingresos.
          </p>
        </Reveal>

        <Reveal delay={0.25} className="mt-10 flex justify-center">
          <PillButton>Agendar una cita</PillButton>
        </Reveal>
      </div>
    </section>
  );
}
